import { render } from "./PartnersSmall.vue?vue&type=template&id=bc880f62"
import script from "./PartnersSmall.vue?vue&type=script&lang=js"
export * from "./PartnersSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__